import type { ProductHit } from '@libs/algolia';
import type { GetRecommendationsParams } from '@libs/common-types';
import { isLocaleCA } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getProductRecommendations(params: GetRecommendationsParams): Promise<ProductHit[]> {
    const url = CWEA_ENDPOINTS.recommendations.getProductRecommendations({
        locale: isLocaleCA() ? 'CA' : 'USA',
        ...params,
    });
    return (
        (await cweaClient.get<ProductHit[]>(url, {
            useOldFetch: true,
        })) ?? []
    );
}
